<template>
  <div>
    <menu-pae :inFocus="false">
      <menu-processo
        v-show="renderizaMenuProcesso"
        :numeroProcesso="numeroProcesso"
        :disableMenuProcesso="disableMenuProcesso"
        :anableButtonEditar="anableButtonEditar"
      />
    </menu-pae>
    <iframe :src="urlVirtus" style="width: 100vw;height: 100vh;"/>
  </div>
</template>

<script>

import menuPae from '@/components/Menu.vue'
import menuProcesso from '@/components/MenuProcesso.vue'

import ProcessoElaboracaoService from '@/services/ProcessoElaboracaoService'
import VirtusService from '@/services/VirtusService'

export default {
  name: 'visualizadorProcesso',

  components: {
    menuPae,
    menuProcesso
  },

  data () {
    return {
      urlVirtus: '',
      numeroProcesso: '',
      renderizaMenuProcesso: true
    }
  },

  created () {
    this.processoElaboracaoService = new ProcessoElaboracaoService()
    this.virtusService = new VirtusService()

    this.numeroProcesso = this.$route.query.numeroProcesso
    this.disableMenuProcesso = this.$route.query.disableMenuProcesso || false
    this.anableButtonEditar = this.$route.query.anableButtonEditar || false
    this.renderizaMenuProcesso = this.$route.query.renderizaMenuProcesso !== undefined ? this.$route.query.renderizaMenuProcesso : this.renderizaMenuProcesso
    this.sessao = this.$store.getters.getDadosSessao.sessao

    this.visualizarProcesso()
  },

  methods: {
    visualizarProcesso () {
      this.processoElaboracaoService.visualizarProcesso(this.numeroProcesso, this.sessao.nomeUsuario, this.sessao.login).then(result => {
        this.urlVirtus = result
      }).catch(err => {
        console.log(err)
      })
    },

    checkDocumento () {
      this.virtusService.existeDocumentoExterno(this.numeroProcesso).then((resp) => {
        this.$store.commit('MUT_COMPONENT_VISIBLE_PROPS', {
          tramitar: resp
        })
      }).catch((err) => {
        console.log(err)
      })
    }
  }
}
</script>

<style scoped>

</style>
